















import { namespace } from 'vuex-class';
import { Component, Mixins } from 'vue-property-decorator';

import { MagicConfigMixin, getTrackingService, ipCountryQuery } from '@gig/magic-common';
import type { OmitFirst } from '@gig/magic-common';
import { NotificationStyle, notificationService } from '@gig/magic-messaging';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

import { config } from '../../services';
import { RouteName } from '../../routes/routes.constants';
import { ACCOUNT_NAMESPACE, actions, getters } from '../../store/modules/account';
import { objectValueOrDefault } from '../../util';
import { toolkit } from '@gig/magic-frontend-toolkit';
import { JurisdictionMixin } from '../../mixins/jurisdiction.mixin';
import { USER_HANDLE_LOGIN, USER_SET_FIRST_LOG_IN } from '@gig/magic-messages';


const accountModule = namespace(ACCOUNT_NAMESPACE);

@Component({
    name: 'regily-manager',
})
export default class RegilyManager extends Mixins(MagicConfigMixin, JurisdictionMixin) {

    @accountModule.Action('setRegilyOpenState')
    setRegilyOpenState!: OmitFirst<typeof actions.setRegilyOpenState>;

    @accountModule.Getter('isRegilyOpen')
    isRegilyOpen!: ReturnType<typeof getters.isRegilyOpen>;

    currentIpCountry: Country | null = null;

    regilyUrl = config.signup.regilyUrl;

    get affiliateTag() {
        return toolkit.affiliate.getAffiliateTag();
    }

    get backTo() {
        return this.$route.params?.backTo || '';
    }

    get isRegilyEnabled() {
        return objectValueOrDefault(config.signup.regilyEnabledCountries, this.currentIpCountry);
    }

    async created() {
        this.currentIpCountry = await ipCountryQuery()
    }
    signupLogin() {
        window.commandBus.publish(USER_SET_FIRST_LOG_IN, true);
        window.eventBus.publish(USER_HANDLE_LOGIN)
    }

    signupError(event: CustomEvent) {
        const [message, code] = event.detail as string[] || [] as string[];
        notificationService.show(message, {
            style: NotificationStyle.ERROR,
            uniqueID: `regily-signup-error-${code}`
        });
        console.error('[Signup error]', message, code);
    }

    signupClose() {
        this.setRegilyOpenState(false);
    }

    signupComplete(authModel: { email: string, btag: string }) {
        getTrackingService().trackRegistrationComplete(authModel.email, authModel.btag);
        this.setRegilyOpenState(false);
        this.$router.push(this.backTo || { name: RouteName.HOME });
    }

    signupAttempt(authModel: { email: string, btag: string }) {
        getTrackingService().trackRegistrationAttempt(authModel.email, authModel.btag);
    }

}
